export const homePageFr =  {
  "Rendez-Vous": "Rendez-Vous",
  "Statistiques Financiéres": "Statistiques Financiéres",
  "Nom ou numero du patient": "Nom ou numero du patient",
  "Nom": "Nom",
  "Matricule": "Matricule",
  "Telephone": "Telephone",
  "Assurances": "Assurances",
  "Laboratoires": "Laboratoires",
  "Utilisateurs": "Utilisateurs",
  "Consommables": "Consommables",
  "Traitements": "Traitements",
  "Roles": "Roles",
  "Mode de paiements": "Mode de paiements",
  "Permissions": "Permissions",
  "Atlas Softwares": "Atlas Softwares",
}
